import React from 'react';
import Tab from '../webcommon/header/tab/Tab';
import { withRouter } from 'react-router';
import styles from './Summary.module.scss';
import tabStyles from './TabOverride.module.scss';
import AppConfig from './appConfig/AppConfig';
import UserProfile from './userProfile/userProfile';

export default (withRouter(() => (
    <div className={styles.summary}>
        <div className={styles.header}>
            Settings
        </div>
        <div className={styles.tabContainer}>
            <Tab
                rememberLastTab
                styles={tabStyles}
                tabs={[
                    { title: 'App Config', path: '/appConfig', component: AppConfig },
                    { title: 'User Profile', path: '/userProfile', component: UserProfile }
                ]}
            />
        </div>
    </div>
)));
